import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import Layout from '../views/layout/Layout'

export const constantRouterMap = [
  {
    path: '/FinancialManagement',
    component: Layout,
    redirect: '/FinancialManagement',
    children: [
      {
        path: 'Reimburse/index',
        name: 'Reimburse/index',
        component: () => import('@/views/FinancialManagement/Reimburse/index'),
        meta: {title: '报销单'},
      },
    ]
  },
  {
    path: '/CardManagement',
    component: Layout,
    redirect: '/CardManagement',
    children: [
      {
        path: 'Card/index',
        name: 'Card/index',
        component: () => import('@/views/CardManagement/Card/index'),
        meta: {title: '电话卡'},
      },
      {
        path: 'ApplyRecord/index',
        name: 'ApplyRecord/index',
        component: () => import('@/views/CardManagement/ApplyRecord/index'),
        meta: {title: '申请记录'}
      },
      {
        path: 'ReportRecord/index',
        name: 'ReportRecord/index',
        component: () => import('@/views/CardManagement/ReportRecord/index'),
        meta: {title: '报表记录'}
      },
    ]
  },
  {
    path: '/sys/department/index',
    component: Layout,
    children: [
      {
        path: '/sys/department/index',
        component: () => import('@/views/sys/department/index'),
        meta: {title: '部门管理'}
      }
    ]
  },

  {
    path: '/sys/user/index',
    component: Layout,
    children: [
      {
        path: '/sys/user/index',
        component: () => import('@/views/sys/user/index'),
        meta: {title: '人员管理'}
      }
    ]
  },
  {
    path: '/sys/clock/index',
    component: Layout,
    children: [
      {
        path: '/sys/clock/index',
        component: () => import('@/views/sys/clock/index'),
        meta: {title: '签到管理'}
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/SystemManagement',
    component: Layout,
    redirect: '/SystemManagement',
    children: [
      {
        path: 'MenuManagement',
        name: 'MenuManagement',
        component: () => import('@/views/SystemManagement/MenuManagement'),
        meta: {title: '菜单管理',},
      },
      {
        path: 'Role',
        name: 'Role',
        component: () => import('@/views/SystemManagement/Role'),
        meta: {title: '角色管理'}
      },
      {
        path: 'PlatformManagement',
        name: 'PlatformManagement',
        component: () => import('@/views/SystemManagement/PlatformManagement'),
        meta: {title: '平台管理'}
      },
    ]
  },
  {
    path: '/HospitalManagement',
    component: Layout,
    redirect: '/HospitalManagement',
    children: [
      {
        path: '/HospitalManagement',
        name: 'HospitalManagement',
        component: () => import('@/views/HospitalManagement/index'),
        meta: {title: '医院管理'}
      }
    ]
  },
  {
    path: '/DataDictionary',
    component: Layout,
    redirect: '/DataDictionary',
    children: [
      {
        path: 'DictionaryManagement',
        name: 'DictionaryManagement',
        component: () => import('@/views/DataDictionary/DictionaryManagement'),
        meta: {title: '字典管理'}
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  },

]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js